<table
    mat-table
    [dataSource]="dataSource"
    matSort
    matSortActive="startDate"
    matSortDirection="desc"
    multiTemplateDataRows>
    @for (column of columnsToDisplay(); track column) {
        <ng-container matColumnDef="{{ column.property }}">
            <th mat-header-cell *matHeaderCellDef [mat-sort-header]="column.property">{{ column.label }}</th>
            <td mat-cell *matCellDef="let element">
                {{ element[column.property] }}
            </td>
        </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="columnNames()"></tr>
    <tr mat-row *matRowDef="let element; columns: columnNames()"></tr>
</table>
<mat-paginator
    [length]="errorData().length"
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 25, 50]"
    (page)="onPageChange($event)"
    showFirstLastButtons />
